import React from "react";

type CardProps = {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  right?: React.ReactNode; // actions area (buttons, filters)
  className?: string;
  headerClassName?: string;
  bodyClassName?: string;
  children: React.ReactNode;
};

export function Card({
  title,
  subtitle,
  right,
  className = "",
  headerClassName = "",
  bodyClassName = "",
  children,
}: CardProps) {
  const hasHeader = title || subtitle || right;

  return (
    <div className={`card ${className}`.trim()}>
      {hasHeader && (
        <div className={`cardHeader ${headerClassName}`.trim()}>
          <div style={{ minWidth: 0 }}>
            {title ? <div className="cardTitle">{title}</div> : null}
            {subtitle ? <div className="cardSub">{subtitle}</div> : null}
          </div>

          {right ? (
            <div style={{ marginLeft: "auto", display: "flex", gap: 10, alignItems: "center" }}>
              {right}
            </div>
          ) : null}
        </div>
      )}

      <div className={bodyClassName}>{children}</div>
    </div>
  );
}

export function CardSection({
  title,
  children,
  right,
}: {
  title: React.ReactNode;
  children: React.ReactNode;
  right?: React.ReactNode;
}) {
  return (
    <div style={{ display: "grid", gap: 10 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div style={{ fontWeight: 1000, letterSpacing: "-0.2px" }}>{title}</div>
        <div style={{ marginLeft: "auto" }}>{right}</div>
      </div>
      {children}
    </div>
  );
}
